/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 OPEN (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by OPEN

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";

// reactstrap components
import {Container, Row, Col, Nav, NavItem, NavLink, Button} from "reactstrap";

class Footer extends React.Component {
    render() {
        return (
            <footer className="footer">
                <hr/>
                <Row className="align-items-center">
                    <Col xl="6">
                        <div className="copyright text-center text-xl-left text-muted">
                            © 2020{" "}
                            <a
                                className="font-weight-bold ml-1"
                                href="https://hello.openmanagerapp.com"
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                OPEN
                            </a>

                            <Button className="btn-icon align-content-center ml-4" color="secondary"
                                    onClick={() => this.showInsta()}
                                    style={{
                                        padding: 0,
                                        textAlign: "center",
                                        alignItems: "center"
                                    }}>
                              <span className="btn-inner--icon my-0 mx-0 px-0 py-0">
                                <img
                                    width={24}
                                    height={24}
                                    alt="pm"
                                    src={require("assets/img/icons/sm/instagram_outline.svg").default}
                                />
                              </span>
                            </Button>
                        </div>
                    </Col>

                    <Col xl="6">
                        <Nav className="nav-footer justify-content-center justify-content-xl-end">
                            {/*<NavItem>*/}
                            {/*    <NavLink*/}
                            {/*        href="https://www.openmanagerapp.com"*/}
                            {/*        rel="noopener noreferrer"*/}
                            {/*        target="_blank"*/}
                            {/*    >*/}
                            {/*        OPEN*/}
                            {/*    </NavLink>*/}
                            {/*</NavItem>*/}

                            {/*<NavItem>*/}
                            {/*    <NavLink*/}
                            {/*        href="https://www.openmanagerapp.com"*/}
                            {/*        rel="noopener noreferrer"*/}
                            {/*        target="_blank"*/}
                            {/*    >*/}
                            {/*        About Us*/}
                            {/*    </NavLink>*/}
                            {/*</NavItem>*/}

                            {/*<NavItem>*/}
                            {/*    <NavLink*/}
                            {/*        href="https://www.openmanagerapp.com"*/}
                            {/*        rel="noopener noreferrer"*/}
                            {/*        target="_blank"*/}
                            {/*    >*/}
                            {/*        Blog*/}
                            {/*    </NavLink>*/}
                            {/*</NavItem>*/}

                            {/*<NavItem>*/}
                            {/*    <NavLink*/}
                            {/*        href="https://www.openmanagerapp.com"*/}
                            {/*        rel="noopener noreferrer"*/}
                            {/*        target="_blank"*/}
                            {/*    >*/}
                            {/*        MIT License*/}
                            {/*    </NavLink>*/}
                            {/*</NavItem>*/}
                        </Nav>
                    </Col>
                </Row>
            </footer>
        );
    }

    showInsta() {
        window.open(`https://www.instagram.com/openmanagerapp/`, "_blank")
    }
}

export default Footer;
